<mat-card class="avatar-select-card">
  <div class="dialog-authentication-header">
    <h2 class="dialog-authentication-title">Wähle deinen <span>Avatar</span></h2>
  </div>

  <mat-icon class="dialog-authentication-back-arrow" (click)="goBack()">arrow_back</mat-icon>

  <mat-card-content>
    <div class="profile-picture-container">
      <img
        [src]="selectedAvatar || 'assets/img-profile/profile.png'"
        alt="Selected Avatar"
        class="profile-picture"
      />
    </div>
    <span class="user-name">{{ userData.name }}</span>

    <p class="avatar-list-title">Aus der Liste wählen</p>

    <div class="avatar-list">
      <img
        (click)="selectAvatar('assets/img-profile/noah-braun.png')"
        src="assets/img-profile/noah-braun.png"
        alt="Avatar Noah Braun"
        class="avatar-image"
        [class.selected]="selectedAvatar === 'assets/img-profile/noah-braun.png'"
      />
      <img
        (click)="selectAvatar('assets/img-profile/sofia-müller.png')"
        src="assets/img-profile/sofia-müller.png"
        alt="Avatar"
        class="avatar-image"
        [class.selected]="selectedAvatar === 'assets/img-profile/sofia-müller.png'"
      />
      <img
        (click)="selectAvatar('assets/img-profile/steffen-hoffmann.png')"
        src="assets/img-profile/steffen-hoffmann.png"
        alt="Avatar Steffen Hoffmann"
        class="avatar-image"
        [class.selected]="selectedAvatar === 'assets/img-profile/steffen-hoffmann.png'"
      />
      <img
        (click)="selectAvatar('assets/img-profile/frederik-beck.png')"
        src="assets/img-profile/frederik-beck.png"
        alt="Avatar Frederik Beck"
        class="avatar-image"
        [class.selected]="selectedAvatar === 'assets/img-profile/frederik-beck.png'"
      />
      <img
        (click)="selectAvatar('assets/img-profile/elise-roth.png')"
        src="assets/img-profile/elise-roth.png"
        alt="Avatar Elise Roth"
        class="avatar-image"
        [class.selected]="selectedAvatar === 'assets/img-profile/elise-roth.png'"
      />
      <img
        (click)="selectAvatar('assets/img-profile/elias-neumann.png')"
        src="assets/img-profile/elias-neumann.png"
        alt="Avatar Elias Neumann"
        class="avatar-image"
        [class.selected]="selectedAvatar === 'assets/img-profile/elias-neumann.png'"
      />
    </div>
  </mat-card-content>

  <mat-card-actions class="dialog-authentication-actions">
    <button
      mat-flat-button
      class="btn-weiter"
      [disabled]="!selectedAvatar"
      (click)="finishSelection()"
    >
      {{ isEditMode ? 'Speichern' : 'Weiter' }}
    </button>
  </mat-card-actions>

  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
</mat-card>
